const MuiDialog = {
    styleOverrides: {
        root: ({ theme })=>({
                '.MuiBackdrop-root': {
                    backgroundColor: theme.palette.background.overlay
                }
            }),
        paper: ({ theme })=>{
            const backgroundImageStyle = 'light' === theme.palette.mode ? {} : {
                backgroundImage: 'unset'
            };
            return {
                ...backgroundImageStyle,
                border: `1px solid ${theme.palette.divider}`
            };
        },
        paperFullScreen: ({ theme })=>{
            const margin = theme.spacing(3);
            const marginPx = parseInt(margin, 10);
            const calcWidth = `calc(100vw - ${2 * marginPx}px)`;
            const calcHeight = `calc(100vh - ${2 * marginPx}px)`;
            return {
                width: calcWidth,
                maxWidth: calcWidth,
                height: calcHeight,
                maxHeight: calcHeight,
                margin: margin
            };
        }
    }
};
const MuiDialogTitle = {
    styleOverrides: {
        root: ({ theme })=>({
                padding: theme.spacing(1, 2)
            })
    }
};
export { MuiDialog, MuiDialogTitle };

//# sourceMappingURL=modal-overrides.js.map